<template>
    <div class="card">
        <div v-if="title || subtitle" :class="compact ? 'px-4 py-3 border-b border-gray-200' : 'card-header-container'">
            <h1 :class="compact ? 'font-semibold text-lg text-gray-600' : 'card-header-title'">{{ title }}</h1>
            <h2 :class="compact ? 'mt-1 font-medium text-sm text-gray-400' : '-mt-4 ml-5 font-medium text-md text-gray-400'" v-if="subtitle">{{ subtitle }}</h2>
        </div>
        <div :class="compact ? 'p-8' : 'p-12'">
            <slot name="form"></slot>
        </div>
        <div v-if="$slots.actions" :class="compact ? 'px-8 pb-8 flex justify-end gap-x-4' : 'px-12 pb-12 flex justify-end gap-x-4'">
            <slot name="actions"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        subtitle: String,
        compact: {
            type: Boolean,
            default: false
        }
    }
}
</script>
